import React, { useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { NavLink }        from 'react-router-dom';

import { getMediaPath } from 'app/functions';
import { getUserOrders } from 'redux/actions';
import * as routes from 'constants/routes';
import './index.scss';
//assets
import shoppingBag from 'assets/icons/shopping-bag-bold.svg';
import arrow from 'assets/icons/arrow-black.svg';
import myOrders from 'assets/icons/my_orders.svg';

const Orders = (props) =>{

    //import redux state
    const text = useSelector(state => state.config.Translations);
    const deviceState = useSelector(state => state.state.deviceState);
    const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';
    const UserData = useSelector(state => state.config.UserData);
    const OrdersList = useSelector(state => state.data.UserOrders);
    const [step, updateStep] = useState(1);
    const [isChecked, setIsChecked] = useState(false);
    const dispatch = useDispatch();

    if(OrdersList === false && !isChecked) {
        setIsChecked(true);
        dispatch(getUserOrders());
    }

    let orders_length = 0;
    if(OrdersList) {
        orders_length = Object.keys(OrdersList).length;
    }

    let getOrders = () =>{

        const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';

        let res = [];

        for(let key in OrdersList){
            const item = OrdersList[key];
            const img_src = item.images ? getMediaPath(item.images[0]) : false;

            const last_digits = UserData.cardsArr.filter(card =>{
                return card.id === item.token_id;
            })?.[0]?.last_digits;

            res.push(
                <div key={key} className='order-wrapper'>
                    <div className='details-container'>
                        <span className={'order-status ' + (item.status_string !== 'open' ? 'done' : '')}>{item.status_string}</span>
                        <div className='details-wrapper'>
                            <span className='title'>מספר הזמנה</span>
                            <span className='text'>{item.order_id}</span>
                        </div>
                        <div className='details-wrapper'>
                            <span className='title'>תאריך הזמנה</span>
                            <span className='text'>{item.order_date}</span>
                        </div>
                        <div className='details-wrapper'>
                            <span className='title'>מספר פריטים</span>
                            <span className='text'>{item.products_num}</span>
                        </div>
                        <div className='details-wrapper'>
                            <span className='title'>שולם</span>
                            <span className='text shekel'>{item.total_sum}</span>
                        </div>
                        <div className='details-wrapper'>
                            <span className='title'>אמצעי תשלום</span>
                            <span className='text'>כרטיס אשראי ({ last_digits })</span>
                        </div>
                        {!isDesktop &&
                            <NavLink to={ routes.personal_zone + routes.personal_zone_routes.my_orders + '/' + item.order_id} className="order-btn">
                                {text['orders_btn']}
                            </NavLink>
                        }
                    </div>
                    {isDesktop &&
                        <div className='bottom-container'>
                            <div className='images-container'>
                                {img_src &&
                                    <img src={ img_src } alt=''/>
                                }
                            </div>
                            <NavLink to={ routes.personal_zone + routes.personal_zone_routes.my_orders + '/' + item.order_id} className="order-btn">
                                {text['orders_btn']}
                            </NavLink>
                        </div>
                    }
                </div>
            )
        }

        return res;
    };
    const handleBackClick = () => {
        if(step === 1) {
            props.history.push(routes.personal_zone);
        } else {
            updateStep(1);
        }
    }

    return(
        <div className="mobile-layout open">
            <div className='top'>
                <div className="wrapper">
                    <img src={isDesktop ? getMediaPath(shoppingBag) : getMediaPath(arrow)} alt='' className="icon" onClick={ handleBackClick } />
                    <span className="title">{ text['personal_zone_orders'] }</span>
                    { isDesktop &&
                        <span className='amount-span'>סה"כ { orders_length } פריטים</span>
                    }
                </div>
                { isDesktop &&
                    <img src={ getMediaPath(myOrders) } className="people" alt='' />
                }
            </div>
            <section className={'orders' + (step === 2 ? 'form-mode' : '')}>
                { (!isDesktop) &&
                    <span className='amount-span'>סה"כ { orders_length } פריטים</span>
                }
                { getOrders() }
            </section>
        </div>
    )
};

export default Orders;
